// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__LAsvW","inner":"Footer_inner__3FdH5","nextIcon":"Footer_nextIcon__jBPCR","innerLeft":"Footer_innerLeft__3sLfx"};